enum OtherIncomeType {
    Annual = 1,
    AnnualAnnuity = 3
}

export default OtherIncomeType;
